import AcceptMeetingComponent from './AcceptMeetingComponent'

export default AcceptMeetingComponent
